<template>
  <section class="drawing-area none">
    <!-- 企業用フレーム(TMFイベント用) -->
    <img
      src="../../assets/images/certificate/frame.png"
      alt=""
      class="background-image"
      v-if="
        isCompany &&
        ($route.query.event === '1000000004' ||
          $route.query.event === '1000000007')
      "
    />
    <!-- VTLH用フレーム -->
    <img
      v-else-if="
        $route.query.event === '0000000039' ||
        $route.query.event === '1000000008'
      "
      src="../../assets/images/certificate/frame_vtlh.png"
      alt=""
      class="background-image"
    />
    <!-- ファミリー陸上(ファミリーの部)イベント -->
    <img
      v-else-if="$route.query.event === '1000000009'"
      src="../../assets/images/certificate/frame_wac_family.png"
      alt=""
      class="background-image"
    />
    <!-- 企業用フレーム -->
    <img
      src="../../assets/images/certificate/company-frame.png"
      alt=""
      class="background-image"
      v-else-if="isCompany"
    />
    <img
      v-else-if="
        $route.query.event === '0000000056' ||
        $route.query.event === '0000000057'
      "
      src="../../assets/images/certificate/frame_vmgc.png"
      alt=""
      class="background-image"
    />
    <!-- INTO KKイベント -->
    <img
      v-else-if="$route.query.event === '0000000095'"
      src="../../assets/images/certificate/frame_intokk.png"
      alt=""
      class="background-image"
    />
    <!-- ファミリー陸上(個人の部)イベント -->
    <img
      v-else-if="$route.query.event === '0000000097'"
      src="../../assets/images/certificate/frame_wac_indivisual.png"
      alt=""
      class="background-image"
    />
    <!-- 通常フレーム -->
    <img
      v-else
      src="../../assets/images/certificate/frame.png"
      alt=""
      class="background-image"
    />
    <!-- -->

    <figure class="certificate">
      <img
        src="../../assets/images/certificate/ttl-certificate.svg"
        alt="certificate"
      />
    </figure>
    <figure class="tmf-virtualrun" :class="{ hidden: isCompany }">
      <span
        class="event-color-border"
        :style="`background-color: ${dataRunner.certificate_detail.event_color_code};`"
      ></span>
      <img
        src="../../assets/images/certificate/ttl-virtualrun.svg"
        alt="tmf virtualrun"
        class="event-logo"
        width="24%"
      />
      <span
        class="event-color-border"
        :style="`background-color: ${dataRunner.certificate_detail.event_color_code};`"
      ></span>
    </figure>
    <div class="event">
      <img
        :src="`../../../static/certificate/${dataRunner.certificate_detail.event_image_file}.png`"
        alt=""
        height="205"
      />
      <div
        class="event-name"
        v-html="
          dataRunner.certificate_detail.nass_event_name.replace('<br>', '\n')
        "
      ></div>
      <div class="event-detail">
        <dl class="event-detail-list">
          <dt class="detail-team font-english">種目 EVENT</dt>
          <dd class="detail-description">
            {{ dataRunner.certificate_detail.nass_course_name }}
          </dd>
        </dl>
        <dl class="event-detail-list">
          <dt class="detail-team font-english">開催日 DATE</dt>
          <dd class="detail-description">
            {{ dataRunner.certificate_detail.event_at }}
          </dd>
        </dl>
      </div>
    </div>

    <!-- チーム -->
    <TeamRanking
      v-if="$route.query.team"
      :is-conversion="true"
      :certificate-width="4000"
      :data-runner="dataRunner"
    ></TeamRanking>
    <!-- 個人 -->
    <PersonalRanking
      v-else
      :is-conversion="true"
      :is-company="isCompany"
      :certificate-width="4000"
      :data-runner="dataRunner"
    ></PersonalRanking>

    <div class="organization">
      <div class="race-director">
        <div class="ja">{{
          dataRunner.certificate_detail.organizer_title
        }}</div>
        <div class="en font-english">{{
          dataRunner.certificate_detail.organizer_title_english
        }}</div>
      </div>
      <div class="race-director-name">
        <div class="ja">{{ dataRunner.certificate_detail.organizer }}</div>
        <div class="en font-english">{{
          dataRunner.certificate_detail.organizer_english
        }}</div>
      </div>
      <img
        v-if="dataRunner.certificate_detail.sign_url"
        :src="dataRunner.certificate_detail.sign_url"
        alt=""
        class="race-director-sign"
      />
    </div>
    <figure class="logo-organization">
      <img
        v-if="dataRunner.certificate_detail.certificate_url"
        :src="dataRunner.certificate_detail.certificate_url"
        :style="logoOrganizationStyle"
        alt=""
      />
    </figure>
    <div class="heed">
      <div>
        この記録証はバーチャルランニングイベントにより記録されたものです。
      </div>
      <div class="font-english">
        *The record displayed is uncertified record from a virtual running
        event.
      </div>
    </div>
  </section>
</template>

<script>
import PersonalRanking from "./PersonalRanking";
import TeamRanking from "./TeamRanking";
export default {
  props: {
    dataRunner: Object,
    isCompany: Boolean,
  },
  components: {
    PersonalRanking,
    TeamRanking,
  },
  computed: {
    logoOrganizationStyle: function () {
      if (this.$route.query.event === "0000000095") {
        // INTO KKイベント
        return { width: "51%" };
      } else if (this.$route.query.event === "0000000097") {
        // ファミリー陸上イベント
        return { width: "17%" };
      } else {
        return { width: "24%" };
      }
    },
  },
  name: "CertificateWidth4000",
};
</script>

<style scoped lang="scss">
$certificate-color: #c9ba87;
$sub-certificate-color: #a8985f;
.font-english {
  font-family: "EB Garamond", sans-serif;
}
.drawing-area {
  width: 4093px;
  height: 2894px;
  text-align: center;
  position: relative;
  top: -9999px;
  left: -9999px;
  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 4093px;
    height: 2894px;
    z-index: -1;
  }
  .certificate {
    padding: 4.5% 0 0 0;
  }
  .tmf-virtualrun {
    margin: 1.75% 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .event-color-border {
      width: 10%;
      height: 0.5em;
    }
    .event-logo {
      margin: 0 1%;
    }
  }
  .event {
    width: 2860px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 4% 0 0 0;
    padding: 0 0 2% 0;
    border-bottom: solid 4px $certificate-color;
    .event-name {
      width: 1280px;
      margin: 0 5% 0 1.2%;
      text-align: left;
      font-size: 50px;
      white-space: pre-line;
    }
    .event-detail {
      .event-detail-list {
        display: flex;
        align-items: center;

        &:not(:first-of-type) {
          margin: 25px 0 0 0;
        }

        .detail-team {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 400px;
          height: 90px;
          margin: 0 6% 0 0;
          border: 4px solid $certificate-color;
          color: $certificate-color;
          font-size: 50px;
        }

        .detail-description {
          font-size: 50px;
          white-space: nowrap;
        }
      }
    }
  }
  .organization {
    margin: 4% 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    font-size: 50px;
    .race-director {
      margin: 0 2.5% 0 0;
    }
    .ja {
      font-weight: bold;
    }
    .race-director-sign {
      width: 442px;
      height: 196px;
      object-fit: contain;
    }
  }
  .logo-organization {
    margin: 1% 0 0 0;
  }
  .heed {
    margin: 2% 0 0 0;
    display: flex;
    justify-content: center;
    font-size: 30px;
  }
  .hidden {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/CertificateWidth4000.vue